import { FC } from 'react';

const ErrorMsg: FC<{ msg: string | undefined }> = ({ msg }) => {
  return <div className="message-error">{msg}</div>;
};

export default ErrorMsg;
